require('../scss/look-search.scss');
const $ = require('jquery');
const {Router} = require('../../../js/common/router');
const tts = require('../../common/js/_tts');
const lang = document.documentElement.lang;
import {currentItem, photoList} from "./_viewer";
import "bootstrap/js/dist/modal";
import {addItem} from "../../request/js/_request";
import imgLazyload from '../../common/js/_img-lazyload';
import initFilters from './_filters-collection';

document.addEventListener('DOMContentLoaded', () =>  {
    initFilters();
    handleRestoredRequestItems();
});

const seeMoreCtn = document.querySelector('.see-more-items');
if (seeMoreCtn) {
    import('../../common/js/_see-more-results').then(({initSeeMore}) => {
        initSeeMore(seeMoreCtn, true);

        document.addEventListener('nextResultsFetched', () => {
            imgLazyload();
        });
    });
}

$('#modal-add-success').on('hide.bs.modal', function () {
    $('#overlay').hide();
}).on('show.bs.modal', function () {
    if ($('#viewer').hasClass('show')) {
        $('#overlay').show();
    }
});

$('.look-checkbox').on('change', function () {
    let count = $('.look-checkbox:checked').length;
    if (count > 0) {
        $('#selected-count').text(Translator.transChoice('btn.add_to_request_list', count, {"count": count}));
        $('#add-form-container').show();
    } else {
        $('#add-form-container').hide();
    }
});

$('#add-form-btn').on('click', function () {
    $(this).prop('disabled', true);
    let items = [];
    Array.from(document.querySelectorAll('.photo-list-item')).map((item, idx) => {
        if (item.querySelector('.look-checkbox:checked')) {
            items.push({
                slug: photoList[idx]['slug'],
                photo: photoList[idx]['medias'][0]['list'],
                designer: photoList[idx]['designerName'],
                season: photoList[idx]['seasonName'],
                look: photoList[idx]['look'],
                reference: photoList[idx]['reference'],
            });
        }
    });
    $('#loading-overlay').fadeIn();
    $.ajax({
        url: Router.generate('request_add.' + lang, {'showroom': document.documentElement.getAttribute('data-showroom')}),
        data: {items: items},
        method: "POST",
        statusCode: {
            403: function () {
                window.location.href = Router.generate(
                    'login' + '.' + document.documentElement.getAttribute('data-showroom') + '.' + lang
                )
            }
        },
        success: function () {
            let ids = items.map(function (item) {
                return item.slug;
            });
            tts.photos('request_add', ids);
            $('#modal-add-success').modal('show');
        }
    }).fail(function (xhr) {
        if (xhr.status !== 403) {
            $('#modal-error').modal('show');
        }
    }).always(function () {
        $('.look-checkbox:checked').prop('checked', false);
        $('#add-form-container').hide();
        $('#add-form-btn').prop('disabled', false);
        $('#loading-overlay').fadeOut();
    });
});

$(document).on('click', '.btn-add-request', function () {
    $('#loading-overlay').fadeIn();
    addItem(currentItem);
});

const handleRestoredRequestItems = () => {
    const restoredRequestItems = document.querySelector('#photo-search').getAttribute('data-restored-request-items');

    if (!restoredRequestItems) {
        return;
    }

    $('#modal-add-success').modal('show');
    const slugs = restoredRequestItems.split(',');
    tts.photos('request_add', slugs);
}
